import { Header } from '@pentabd/ui';
import { useTranslation } from 'react-i18next';
import { Countdown } from '../countdown';
import { API_REFETCH_TIME } from '../options';

export const DashboardHeader = ({ isLoading }: { isLoading: boolean }) => {
  const { t } = useTranslation();

  const headerText = {
    header: t(`DASHBOARD.DASHBOARD_TITLE`),
  };

  return (
    <div className="mt-20">
      <Header
        headerText={headerText}
        actions={[
          <Countdown refetch_time={API_REFETCH_TIME} isLoading={isLoading} />,
        ]}
      />
    </div>
  );
};
